import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_AboutUs = _resolveComponent("AboutUs", true)!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { titleId: 4 }),
    _createVNode(_component_AboutUs, {
      companyProfile: _ctx.companyProfile,
      connectUs: _ctx.connectUs
    }, null, 8, ["companyProfile", "connectUs"]),
    _createVNode(_component_Bottom)
  ]))
}